import React, { useEffect } from "react";
import ReactDOM from "react-dom/client";
// import "./index.css";
import App from "./App";
import Home from "./components/Home.js";
import ProductDetail from "./components/ProductDetail.js";
import FilterProduct from "./components/FilterProduct.js";
import CheckOut from "./components/CheckOut.js";
import OrderThankyouPage from "./components/OrderThankyouPage.js";
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

import { Provider } from "react-redux";
import {store} from "./store/index";
import { VENDOR_URL } from "./Constants.js";
import { fetchContentData } from "./store/ContentAction.js";
import { fetchVenueInfo } from "./store/slice/venueSlice.js";
import { fetchMenuFeedApi } from "./store/MenuFeedaction.js";
import { fetchMerchantInfo } from "./store/actions.js";
import { getDiscountData } from "./store/discountAction.js";
import { getSdpData } from "./store/SdpAction.js";
import { isWordPress } from "./utility/generalUtils";
import axios from "axios";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        path: "/",
        element: <Home />
      },
      {
        path: "/:brands?/:product_id",
        element: <ProductDetail />
      },
      {
        path: "/checkout",
        element: <CheckOut />
      },
      {
        path: "/thank-you",
        element: <OrderThankyouPage />
      },
      {
        path: "/products",
        element: <FilterProduct />
      }
    ]
  }
], {
  basename: window.posabitmenuwidget.config.basename
}
);

async function fetchSettingsAndInitialize() {
  store.dispatch(fetchMerchantInfo());
  store.dispatch(fetchVenueInfo());
  store.dispatch(fetchContentData());
  store.dispatch(fetchMenuFeedApi());
  store.dispatch(getDiscountData());
  store.dispatch(getSdpData());
}

// this prevents wordpress multi location shortcode override from working
// async function fetchSettingsAndInitialize() {
//   try {
//     if (!await isWordPress()) {
//       console.log("Not a WordPress site, skipping settings fetch");
//       store.dispatch(fetchMerchantInfo());
//       store.dispatch(fetchVenueInfo());
//       store.dispatch(fetchContentData());
//       store.dispatch(fetchMenuFeedApi());
//       store.dispatch(getDiscountData());
//       store.dispatch(getSdpData());
//     } else {
//       console.log("Fetching settings from WordPress");
//       const response = await fetch('/wp-json/posabit-menu/v1/config');
//       const text = await response.text(); // Read the raw response as text
//       try {
//         const settings = JSON.parse(text); // Attempt to parse it as JSON
//         console.log({settings})
//
//         if (settings.server_host && settings.ecomm_url) {
//           const url = `${settings.server_host}/mcx/site/lookup`;
//           console.log({url});
//
//           axios.post(url, { url: settings.ecomm_url })
//             .then((response) => {
//               const config = response.data;
//               console.log({config});
//               // Update session storage with config
//               sessionStorage.setItem('merchantToken', config.merchant.token);
//               sessionStorage.setItem('selectedVenue', config.venue.slug);
//               sessionStorage.setItem('merchantSlug', config.merchant.slug);
//               sessionStorage.setItem('feedId', config.menu.feed_key);
//               sessionStorage.setItem('previewMode', config.menu.preview_mode || false);
//               sessionStorage.setItem('apiHost', config.menu.server_host);
//             })
//             .then((res) => {
//               console.log("\n\nSettings fetched successfully\n\n");
//               store.dispatch(fetchMerchantInfo());
//               store.dispatch(fetchVenueInfo());
//               store.dispatch(fetchContentData());
//               store.dispatch(fetchMenuFeedApi());
//               store.dispatch(getDiscountData());
//               store.dispatch(getSdpData());
//               return res;
//             }
//             )
//             .catch((error) => {
//               console.error("Axios Error:", error);
//             });
//             return
//         } else {
//           console.error("Missing server_host or ecomm_url in settings");
//         }
//       } catch (parseError) {
//         console.error("Error parsing settings JSON:", parseError);
//       }
//     }
//
//     // Dispatch Redux actions after session storage is updated
//
//   } catch (error) {
//     console.error('Error fetching settings:', error);
//
//     // Fallback to window.posabitmenuwidget.config if settings fetch fails
//     store.dispatch(fetchMerchantInfo());
//     store.dispatch(fetchVenueInfo());
//     store.dispatch(fetchContentData());
//     store.dispatch(fetchMenuFeedApi());
//     store.dispatch(getDiscountData());
//     store.dispatch(getSdpData());
//   }
// }

async function main() {
  // Check Query Params for overrides and set them in local storage
  const queryParams = new URLSearchParams(window.location.search);

  if (queryParams.has("merchant_token")) {
    sessionStorage.setItem('merchantToken', queryParams.get("merchant_token"));
  } else {
    sessionStorage.setItem('merchantToken', window.posabitmenuwidget.config.merchant_token);
  }

  if (queryParams.has("venue_slug")) {
    sessionStorage.setItem('selectedVenue', queryParams.get("venue_slug"));
  } else {
    sessionStorage.setItem('selectedVenue', window.posabitmenuwidget.config.venue_slug);
  }

  if (queryParams.has("merchant_slug")) {
    sessionStorage.setItem('merchantSlug', queryParams.get("merchant_slug"));
  } else {
    sessionStorage.setItem('merchantSlug', window.posabitmenuwidget.config.merchant_slug);
  }

  if (queryParams.has("initial_feed")) {
    sessionStorage.setItem('feedId', queryParams.get("initial_feed"));
  } else {
    sessionStorage.setItem('feedId', window.posabitmenuwidget.config.initial_feed_id);
  }

  if (queryParams.has("preview_mode")) {
    sessionStorage.setItem('previewMode', queryParams.get("preview_mode"));
  } else {
    sessionStorage.setItem('previewMode', window.posabitmenuwidget.config.preview_mode || false);
  }

  let apiHost = "";

  if (window.posabitmenuwidget.config.server_host) {
    apiHost = window.posabitmenuwidget.config.server_host;
  } else {
    let environment = "development";
    apiHost = VENDOR_URL;
    if (queryParams.has("environment")) {
      environment = queryParams.get("environment");
    } else {
      environment = window.posabitmenuwidget.config.environment;
    }

    if (environment === "development") {
      apiHost = "http://localhost:3000";
    } else if (environment === "vendor") {
      apiHost = VENDOR_URL;
    } else if (environment === "qa") {
      apiHost = "https://qa-app.posabit.com";
    } else {
      apiHost = "https://app.posabit.com";
    }
  }

  sessionStorage.setItem('apiHost', apiHost);

  // Fetch settings and initialize Redux store
  await fetchSettingsAndInitialize();
}

main();

function AppWithInterval() {
  useEffect(() => {
    const intervalId = setInterval(main, 20 * 60 * 1000);

    return () => clearInterval(intervalId); // Cleanup the interval on unmount
  }, []);

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppWithInterval />
  </React.StrictMode>
);

